export default function Obf() {
  
  function reverseString(str) {
    return str.split('').reverse().join('');
  }

  const handleEmail = () => {
    const emails = document.querySelectorAll('[data-w-obf-eml]');
    emails.forEach((element) => {
      const email = `${reverseString(
        element.getAttribute('data-w-obf-eml-p')
      )}@${reverseString(element.getAttribute('data-w-obf-eml-s'))}`;
      const emailText = `${reverseString(
        element.getAttribute('data-w-obf-eml-p')
      )}@<wbr />${reverseString(element.getAttribute('data-w-obf-eml-s'))}`;

      const anchor = document.createElement('a');
      anchor.classList = element.classList;
      anchor.setAttribute('href', 'mailto:' + email);
      anchor.innerHTML = emailText;
      element.parentNode.replaceChild(anchor, element);
    });
  }

  const handleTel = () => {
    const tels = document.querySelectorAll('[data-w-obf-tel]');
    tels.forEach((element) => {
      const telText = reverseString(
        element.getAttribute('data-w-obf-tel')
      );
      const tel = telText.replace(/\s/g, '').replace(/\+/g, '00');

      const anchor = document.createElement('a');
      anchor.classList = element.classList;
      anchor.setAttribute('href', 'tel:' + tel);
      anchor.innerHTML = telText;
      element.parentNode.replaceChild(anchor, element);
    });
  }

  return {
    init: () => {
      handleEmail();
      handleTel();
  
      // document.addEventListener(
      //   'w.ObfEmlHandler.parse',
      //   (event) => {
      //     parse();
      //   },
      //   false
      // );
    }
  };
}
